(function ($) {
    var mapsToLoad = [],
        scriptLoaded = false;

    // jQuery plugin to enable google map components
    $.fn.googleMap = function () {
        if (!scriptLoaded) {
            mapsToLoad.push(this);
            return;
        }

        var isDraggable = !evo.$.html.hasClass('touch');

        return $(this).not('.loaded').addClass('loaded').each(function () {
            var $this = $(this),

                markers = $this.find('.js-google-map-marker').map(function () {
                    var $marker = $(this);

                    return {
                        animation: google.maps.Animation[$marker.data('animation') || 'DROP'],
                        title: $marker.data('title'),
                        label: $marker.data('label'),
                        position: {
                            lat: parseFloat($marker.data('lat') || 0),
                            lng: parseFloat($marker.data('lon') || 0)
                        }
                    };
                }).get();

            var mapOptions = {
                mapTypeId: google.maps.MapTypeId[$this.data('google-map') || 'SATELLITE'],
                scrollwheel: false,
                rotateControl: true,
                zoom: $this.data('zoom') || 8,
                draggable: isDraggable,
                center: new google.maps.LatLng({
                    lat: markers.reduce(function (t, m) { return t + (m.position.lat / markers.length); }, 0),
                    lng: markers.reduce(function (t, m) { return t + (m.position.lng / markers.length); }, 0)
                })
            };

            var map = new google.maps.Map($this.get(0), mapOptions),
                infoWindows = [];

            _.each(markers, function (m) {
                m.position = new google.maps.LatLng(m.position);
                m.map = map;
                var marker = new google.maps.Marker(m);
                var info = new google.maps.InfoWindow({
                    content: m.title
                });
                infoWindows.push(info);
                marker.addListener('click', function () {
                    infoWindows.forEach(function (i) { i && i.close(); });
                    info.open(map, marker);
                });
            });

            $this.removeClass('loading');

            // Allow pages to trigger a 're-initialize' of the maps
            $('body').on('reinit.evo.maps', function () {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(mapOptions.center);
            });
        });
    };
    $(function () {
        evo.loadScript('//maps.googleapis.com/maps/api/js?key=AIzaSyCD-pRAl00-R2lN-eX-em4Z59EVsa8ix4o').done(function () {
            scriptLoaded = true;
            $(mapsToLoad).each(function () {
                $(this).googleMap();
            });
            delete mapsToLoad;
        });
    });

    $('[data-google-map]').googleMap();
})(jQuery);